import React from "react";
import { connect } from "react-redux";
import { Container, Row, Col, Card, CardBody, Button, Badge as BadgeUI } from "reactstrap";
import NotificationAlert from "react-notification-alert";
import Swal from "sweetalert2";
import api from "./../../../Api.js";
import SimpleHeader from "./../../../components/Headers/SimpleHeader.jsx";

/**
 * SkillPicker — escolha de habilidade no level 2+ (regra 10).
 */
class SkillPicker extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      skills: [],
      owned: [],
      canChoose: false,
      loading: true
    };
  }

  async componentDidMount() {
    await this.loadSkills();
  }

  async loadSkills() {
    try {
      var res = await api.shopSkills();
      this.setState({
        skills: res.data.skills || [],
        owned: res.data.owned || [],
        canChoose: res.data.canChoose,
        loading: false
      });
    } catch (e) {
      this.setState({ loading: false });
    }
  }

  notify(type, title, message) {
    try {
      this.refs.notificationAlert.notificationAlert({
        place: 'tr',
        message: <div className="alert-text"><span className="alert-title">{title}</span><span> {message}</span></div>,
        type: type, icon: 'ni ni-check-bold', autoDismiss: 5
      });
    } catch (e) {}
  }

  async choose(skill) {
    var confirm = await Swal.fire({
      title: 'Escolher ' + skill.name + '?',
      html: (skill.description ? skill.description + '<br/><br/>' : '') + 'Essa habilidade ficará equipada no seu herói.',
      icon: 'question',
      showCancelButton: true,
      confirmButtonColor: '#28a745',
      cancelButtonColor: '#dc3545',
      confirmButtonText: '<i class="fas fa-bolt"></i> Escolher',
      cancelButtonText: '<i class="fas fa-times"></i> Cancelar'
    });
    if (!confirm.isConfirmed) return;
    try {
      var res = await api.shopChooseSkill(skill.id);
      if (res.data && res.data.success) {
        this.notify('success', '⚡ Habilidade desbloqueada', skill.name);
        await this.loadSkills();
      } else {
        this.notify('warning', 'Erro', (res.data && res.data.error) || 'Falha');
      }
    } catch (e) {
      this.notify('warning', 'Erro', 'Falha ao escolher');
    }
  }

  isOwned(skillId) {
    return this.state.owned.some(function (o) { return o.skill === skillId || o.id === skillId; });
  }

  render() {
    var skills = this.state.skills;

    return (
      <React.Fragment>
        <div className="rna-wrapper"><NotificationAlert ref="notificationAlert" /></div>
        <SimpleHeader name="⚡ Habilidades" way={[{ name: "Habilidades", url: "/shop/skills" }]} />

        <Container className="mt--6" fluid>
          {!this.state.canChoose && (
            <Card className="shadow mb-3" style={{ background: 'linear-gradient(135deg, #ffc107, #ff9800)', color: '#fff', border: 'none' }}>
              <CardBody className="text-center">
                <i className="fas fa-lock fa-2x mb-2" />
                <h4>Habilidades bloqueadas</h4>
                <p className="mb-0">Suba para o nível 2 para escolher sua primeira habilidade!</p>
              </CardBody>
            </Card>
          )}

          <Row>
            {this.state.loading ? (
              <Col className="text-center py-5"><i className="fas fa-spinner fa-spin fa-2x" /></Col>
            ) : (
              skills.map((skill) => {
                var owned = this.isOwned(skill.id);
                return (
                  <Col md="6" lg="4" xl="3" key={skill.id} className="mb-3">
                    <Card className="shadow h-100" style={{
                      border: owned ? '3px solid #FFD700' : '1px solid #eee',
                      transition: 'all 0.2s'
                    }}>
                      <CardBody className="text-center">
                        <div style={{
                          width: '60px', height: '60px', margin: '0 auto 10px',
                          background: 'linear-gradient(135deg, #6f42c1, #9c27b0)',
                          borderRadius: '50%',
                          display: 'flex', alignItems: 'center', justifyContent: 'center',
                          color: '#fff', fontSize: '1.5rem',
                          boxShadow: '0 4px 12px rgba(111,66,193,0.4)'
                        }}>
                          <i className={skill.icon || 'fas fa-magic'} />
                        </div>
                        <h5>{skill.name}</h5>
                        <p className="text-muted" style={{ fontSize: '0.85rem', minHeight: '40px' }}>{skill.description}</p>
                        <BadgeUI color="info" pill className="mb-2" style={{ fontSize: '0.7rem' }}>
                          {skill.classRequired}
                        </BadgeUI>
                        {owned ? (
                          <Button color="success" disabled block>
                            <i className="fas fa-check mr-1" /> Equipada
                          </Button>
                        ) : (
                          <Button
                            color="primary"
                            block
                            onClick={() => this.choose(skill)}
                            disabled={!this.state.canChoose}
                          >
                            <i className="fas fa-bolt mr-1" /> Escolher
                          </Button>
                        )}
                      </CardBody>
                    </Card>
                  </Col>
                );
              })
            )}
          </Row>
        </Container>
      </React.Fragment>
    );
  }
}

export default connect(state => ({ user: state.user }))(SkillPicker);
